<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :loading="loading"
            :pageTotal="pageTotal"
            :searchTotalTitle="searchTotalTitle"
            :totalData="totalData"
            class="algorithm-parameters"
            pageID="algorithmParameters"
            searchId="algorithmParameters"
            @btnClick="btnClick"
            @pageChange="pageChange"
            @searchChange="searchChange"
            @selectChange="selectChange"
            @sizeChange="sizeChange"
            @edit-btn="editBtn"
            @enable-btn="enableBtn"
            @disable-btn="disableBtn"
        >
            <span slot="search-list-advance-right">
                <el-button class="reset" @click="reset">重 置</el-button>
            </span>
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="REPORT_OTP_ALGORTHM_PARAMSTERS"
                >
                    <el-tooltip content="导出" effect="dark" placement="bottom">
                        <span v-has="'otp02050001'">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button v-has="'otp02050002'" type="primary" @click="addBtn"
                    >新 增</el-button
                >
                <el-button v-has="'otp02050003'" type="primary" @click="delBtn"
                    >删 除</el-button
                >
            </div>
        </m-pane>
        <edit-dialog
            v-if="editDialogVisible"
            :dialogVisible.sync="editDialogVisible"
            :rowData="rowData"
            :title="title"
            :type="type"
            @handleClose="handleClose"
        ></edit-dialog>
    </paper>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import EditDialog from './components/EditDialog';
import reportExport from '@/components/lots/reportExportPlugin';
import { deleteByIds, editDate, getSearchList } from '../../../api/algorithmParameters';
import { mapState } from 'vuex';

export default {
    name: 'algorithmParameters',
    components: { mPane, paper, EditDialog, reportExport },
    data () {
        return {
            config: config,
            totalData: [],
            loading: false,
            editDialogVisible: false,
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            title: '新增',
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                orderBy: 'updateTime',
                orderByType: 'desc'
            },
            rowData: {},
            isFirstSearch: true,
            type: '',
            selectData: []
        };
    },
    methods: {
        // 重置查询参数
        reset () {
            this.$refs.tablePage.$refs.searchList.dataInit(null, true);
        },
        selectChange (data) {
            this.selectData = data;
        },
        addBtn () {
            this.title = '新增';
            this.type = 'add';
            this.rowData = {};
            this.editDialogVisible = true;
        },
        editBtn (rowData) {
            this.title = '编辑';
            this.type = 'edit';
            this.rowData = rowData;
            this.editDialogVisible = true;
        },
        btnClick (val, index, rowData) {
            this.title = '查看';
            this.type = 'check';
            this.rowData = rowData;
            this.editDialogVisible = true;
        },
        handleClose (val) {
            if (val) {
                this.getList();
            }
            this.editDialogVisible = false;
        },
        getList () {
            this.isFirstSearch = false;
            this.loading = true;
            getSearchList(this.searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list || [];
                    this.totalData.forEach(item => {
                        item.hiddenEvent = [];
                        if (+item.algorithmStatus === 1) {
                            item.algorithmStatusName = '停用';
                            item.hiddenEvent = ['disable'];
                        } else {
                            item.algorithmStatusName = '启用';
                            item.hiddenEvent = ['edit', 'enable'];
                        }
                    });
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        // 删除
        delBtn () {
            if (!this.selectData.length) {
                return this.$message.warning('请先勾选数据!');
            }
            let delCheck = 0;
            delCheck = (this.selectData.filter(item => +item.algorithmStatus === 0)).length;
            if (delCheck) {
                return this.$message.warning('选择的数据存在启用,不允许删除!');
            }
            this.$confirm('请确认是否删除选中数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ids = [];
                ids = this.selectData.map(item => item.id);
                deleteByIds(ids).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功');
                        this.getList();
                    }
                });
            });
        },
        enableBtn (rowData) {
            rowData.algorithmStatus = 0;
            this.handleSave(rowData, '启用成功');
        },
        disableBtn (rowData) {
            rowData.algorithmStatus = 1;
            this.handleSave(rowData, '停用成功');
        },
        handleSave (rowData, message) {
            editDate(rowData, rowData.id).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(`${message}`);
                    this.getList();
                }
            });
        },
        // 导出
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchParams,
                suppliersCode: this.supplier.supplierCode,
                beginDate2: '2020-11-11 00:00:00', // 后端固定要传参数
                endDate2: '2030-11-11 00:00:00'
            });
            this.isFirstSearch = false;
        },
        searchChange (data) {
            delete data.siteName;
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            this.getList();
        },
        pageChange (data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange (data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.searchParams.pageNo = 1;
            this.getList();
        }
    },
    mounted () {
        this.getList();
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
        })
    }
};
</script>
<style lang="less" scoped>
.algorithm-parameters {
    .button {
        margin-right: 10px;
    }

    .reset {
        margin-left: 10px;
    }
}
</style>
